function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useEffect, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { pushRiskDashboardColumns, pushRiskDrillColumns } from '../../../slices/RiskFilterSlice';
import columnIcon from '../../../assets/img/column.svg';
import activeColumnIcon from '../../../assets/img/column-active.svg';
import { ClickAwayListener, Grow, MenuList, Paper, Checkbox, Tooltip } from '@material-ui/core';
import { StyledButton, StyledPopper, StyledReorderContainer, StyledMenuItem } from './DropDownMenuStyles';
import { pushRecommendationColumnData, pushRecommendationApplicationColumnData, pushRecommendationEnvironmentColumnData } from '../../../slices/recommendationTableSlice';
import { AiOutlineFlag } from 'react-icons/ai';

const DropDownMenu = props => {
  const dispatch = useDispatch();
  const clickEvent = useSelector(state => state.applicationDrillHeatMap.clickEvent);
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const {
    menuItems = [],
    isRiskTable
  } = props;
  const handleToggle = useCallback(() => {
    setOpen(prevOpen => !prevOpen);
  }, [open]);
  const handleClose = useCallback(() => {
    setOpen(false);
  }, [open]);
  const handleListKeyDown = useCallback(event => {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }, [open]);
  const prevOpen = useRef(open);
  useEffect(() => {
    if (prevOpen.current == true && open == false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);
  const onCheckBoxClick = useCallback(name => {
    let cloneCols = JSON.parse(JSON.stringify(menuItems));

    for (let col of cloneCols) {
      if (name === col.accessor) {
        col.hidden = !col.hidden;
      }
    }

    if (isRiskTable) {
      if (clickEvent) {
        dispatch(pushRiskDrillColumns(cloneCols));
      } else {
        dispatch(pushRiskDashboardColumns(cloneCols));
      }
    } else {
      if (props && props.pageType) {
        switch (props.pageType) {
          case 'application':
            dispatch(pushRecommendationColumnData(cloneCols));
            break;

          case 'environment':
            dispatch(pushRecommendationApplicationColumnData(cloneCols));
            break;

          case 'entity':
            dispatch(pushRecommendationEnvironmentColumnData(cloneCols));
            break;

          default:
            break;
        }
      }
    }
  }, [menuItems]);
  let src = open ? activeColumnIcon : columnIcon;
  return /*#__PURE__*/React.createElement(StyledReorderContainer, null, /*#__PURE__*/React.createElement(Tooltip, {
    title: "Column Configuration"
  }, /*#__PURE__*/React.createElement(StyledButton, {
    ref: anchorRef,
    "aria-haspopup": "true",
    startIcon: /*#__PURE__*/React.createElement("img", {
      src: src
    }),
    onClick: handleToggle,
    isOpen: open
  })), /*#__PURE__*/React.createElement(StyledPopper, {
    open: open,
    anchorEl: anchorRef.current,
    transition: true,
    disablePortal: true,
    placement: "bottom-end"
  }, ({
    TransitionProps,
    placement
  }) => /*#__PURE__*/React.createElement(Grow, _extends({}, TransitionProps, {
    style: {
      transformOrigin: placement === 'bottom' ? 'center top' : 'right top'
    }
  }), /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(ClickAwayListener, {
    onClickAway: handleClose
  }, /*#__PURE__*/React.createElement(MenuList, {
    autoFocusItem: open,
    onKeyDown: handleListKeyDown
  }, menuItems.map((col, index) => col.accessor !== 'underWatch' && /*#__PURE__*/React.createElement(StyledMenuItem, {
    key: index,
    index: index,
    onClick: () => onCheckBoxClick(col.accessor)
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: !col.hidden,
    name: col.accessor,
    id: `${col.Header}${index}`,
    color: "primary"
  }), /*#__PURE__*/React.createElement("span", {
    title: col.Header,
    className: "menu-title"
  }, col.Header == '' ? /*#__PURE__*/React.createElement(AiOutlineFlag, null) : /*#__PURE__*/React.createElement("span", null, col.Header))))))))));
};

export default DropDownMenu;